export { renderMenuTrigger_unstable as renderMenuTrigger } from '@fluentui/react-menu';
